var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { animated, to } from '@react-spring/web';
import { useSpringValues } from '../hooks/use-spring-values';
import { useStaticColors } from '../hooks/use-theme-colors';
var cls = classNames('compass-star');
export var SvgCompassStarDefaultProps = {
  colors: {
    fill: 'bright'
  },
  innerRadius: 20,
  outerRadius: 100,
  numPoints: 8,
  cx: 0,
  cy: 0,
  strokeWidth: 0,
  animate: true,
  springConfig: {
    tension: 170,
    friction: 26,
    mass: 1
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var PathStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var colors = _a.colors;
    return theme.STROKE_FILL_COLORS({
      colors: colors,
      isActive: false
    });
  })
});
// -------- Components -------->
var My = {
  Container: styled(animated.svg)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Path: styled(animated.path)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), PathStyles)
};
export var SvgCompassStar = function (props) {
  var className = props.className,
    innerRadius = props.innerRadius,
    outerRadius = props.outerRadius,
    numPoints = props.numPoints,
    cx = props.cx,
    cy = props.cy,
    strokeWidth = props.strokeWidth,
    mask = props.mask,
    clip = props.clip;
  var alternateOuterRadius = props.alternateOuterRadius || outerRadius;
  var colors = useStaticColors(props.colors);
  var values = useSpringValues(props);
  var pathData = React.useCallback(function (innerRadius, outerRadius, alternateOuterRadius, numPoints, cx, cy) {
    var points = [];
    for (var i = 0; i < numPoints * 2; i++) {
      var angle = i / (numPoints * 2) * Math.PI * 2;
      var radius = i % 2 === 0 ? outerRadius : innerRadius;
      if (i % 2 === 0) {
        radius = i % 4 === 0 ? outerRadius : alternateOuterRadius;
      }
      var x = cx + Math.cos(angle) * radius;
      var y = cy + Math.sin(angle) * radius;
      points.push([x, y]);
    }
    return points.map(function (point, i) {
      return "".concat(i === 0 ? 'M' : 'L').concat(point[0], ",").concat(point[1]);
    }).join(' ') + 'Z';
  }, [innerRadius, outerRadius, alternateOuterRadius, numPoints, cx, cy]);
  var width = Math.max(outerRadius, alternateOuterRadius) * 2;
  var height = width;
  return React.createElement(My.Container, {
    mask: mask,
    clip: clip,
    overflow: "visible",
    width: width,
    height: height,
    viewBox: "0 0 ".concat(width, " ").concat(height),
    className: cls.name(className)
  }, React.createElement(My.Path, {
    colors: props.colors,
    d: to([values.innerRadius, values.outerRadius, values.alternateOuterRadius, values.numPoints, values.cx, values.cy], pathData),
    fill: colors.fill,
    stroke: colors.stroke,
    strokeWidth: strokeWidth
  }));
};
SvgCompassStar.cls = cls;
SvgCompassStar.defaultProps = SvgCompassStarDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;